// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* LOGIN PAGE.............................. */
.loginuserid,
.loginpassword,
.forgotpassword,
.signintittle,
.galaxsite,
.copyright {
  color: #103c5e;
}

.loginuserid,
.loginpassword,
.forgotpassword {
  font-size: 14px;
}

.useridinput,
.passwordinput {
  padding-right: 32px !important;
}

.signinbutton {
  background: #103c5e !important;
  color: white !important;
  transition: 1s;
}
.signinbutton:hover {
  background: transparent !important;
  font-weight: 600 !important;
  color: #103c5e !important;
  border: 1px solid #103c5e !important;
}
.signinbutton:focus {
  background: transparent !important;
  border: 1px solid #103c5e !important;
  color: #103c5e !important;
}

.passwordSection {
  position: relative;
}
.passwordSection .passwordIcon {
  position: absolute;
  bottom: 7px;
  right: 10px;
}

.Login_Page {
  margin: 0;
  padding: 0;
  display: grid;
  place-content: center;
  min-height: 100vh;
}

.login__page_wrapper {
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px 8px;
  padding: 30px;
  border-radius: 10px;
}`, "",{"version":3,"sources":["webpack://./src/Styles/Login.scss"],"names":[],"mappings":"AAAA,6CAAA;AAEA;;;;;;EAME,cAAA;AAAF;;AAGA;;;EAGE,eAAA;AAAF;;AAGA;;EAEE,8BAAA;AAAF;;AAGA;EACE,8BAAA;EACA,uBAAA;EACA,cAAA;AAAF;AAEE;EACE,kCAAA;EACA,2BAAA;EACA,yBAAA;EACA,oCAAA;AAAJ;AAGE;EACE,kCAAA;EACA,oCAAA;EACA,yBAAA;AADJ;;AAKA;EACE,kBAAA;AAFF;AAIE;EACE,kBAAA;EACA,WAAA;EACA,WAAA;AAFJ;;AAKA;EACE,SAAA;EACA,UAAA;EACA,aAAA;EACA,qBAAA;EACA,iBAAA;AAFF;;AAKA;EACE,qDAAA;EACA,aAAA;EACA,mBAAA;AAFF","sourcesContent":["/* LOGIN PAGE.............................. */\n\n.loginuserid,\n.loginpassword,\n.forgotpassword,\n.signintittle,\n.galaxsite,\n.copyright {\n  color: #103c5e;\n}\n\n.loginuserid,\n.loginpassword,\n.forgotpassword {\n  font-size: 14px;\n}\n\n.useridinput,\n.passwordinput {\n  padding-right: 32px !important;\n}\n\n.signinbutton {\n  background: #103c5e !important;\n  color: white !important;\n  transition: 1s;\n\n  &:hover {\n    background: transparent !important;\n    font-weight: 600 !important;\n    color: #103c5e !important;\n    border: 1px solid #103c5e !important;\n  }\n\n  &:focus {\n    background: transparent !important;\n    border: 1px solid #103c5e !important;\n    color: #103c5e !important;\n  }\n}\n\n.passwordSection {\n  position: relative;\n\n  .passwordIcon {\n    position: absolute;\n    bottom: 7px;\n    right: 10px;\n  }\n}\n.Login_Page {\n  margin: 0;\n  padding: 0;\n  display: grid;\n  place-content: center;\n  min-height: 100vh;\n}\n\n.login__page_wrapper {\n  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px 8px;\n  padding: 30px;\n  border-radius: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
